Dates = require 'lib/dates'
LegacyPowerUps = require 'data/legacy-power-ups'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
template = require 'views/templates/date_picker'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
moment = require 'moment'
Pikaday = require 'pikaday'
l = require 'lib/localize'
ClientConfig = require 'debug/client-config'

getPikadayStrings = ->
  previousMonth: l('prev month button text')
  nextMonth: l('next month button text')
  months: moment.months('MMMM')
  weekdays: moment.weekdays('dddd')
  weekdaysShort: moment.weekdaysMin('dddd')

timeFormat = 'LT'
parseFormat = [timeFormat, 'h:mm A']
isTimeStringValid = (string) -> moment(string, parseFormat).isValid()

module.exports = class DatePickerView extends View
  viewTitleKey: 'change due date'
  tagName: 'form'
  className: 'dpicker-widget u-clearfix'

  events:
    'click .js-remove-date': 'removeDueDate'
    'input .js-dpicker-time-input': 'validateTimeInput'
    'change .js-dpicker-time-input': 'normalizeTimeInput'
    'click a[href="/business-class"]': ->
      track('Card Detail', 'Click Business Class Link', 'Date Picker PopOver')
    'submit': (e) ->
      e.preventDefault()
      @submitDueDate()
    'click .js-enable-calendar-powerup': (e) ->
      e.preventDefault()
      @enableCalendarPowerUp()

  initialize: ->
    @listenTo @model.getBoard(), 'change:powerUps', @renderCalendarPowerUp

  getSelectedDueDateMoment: ->
    date = @picker.getMoment()
    if !date.isValid()
      return null

    # Pikaday requires a single date format, and will parse it strictly (which
    # is good). However, this means an entry like '2/14/15' will parse as
    # '02/14/0015', which isn't great.
    if date.year() < 1000
      date.add(2000, 'years')

    time = @selectedTimeMoment()
    date
    .hour time.hour()
    .minute time.minute()

  submitDueDate: ->
    dueDateMoment = @getSelectedDueDateMoment()
    if dueDateMoment?
      @setDueDate dueDateMoment.toDate()
    else
      @removeDueDate()

  setDueDate: (date) ->
    DatePickerView.lastDueDate = date
    @model.update('due', date.getTime())
    PopOver.hide()

  removeDueDate: ->
    if @model.get('due')
      @model.update('due', null)
    PopOver.hide()


  renderCalendarPowerUp: ->
    $show = @$('.js-cal-enabled').addClass('hide')
    $cal = @$('.js-enable-cal').addClass('hide')

    board = @model.getBoard()
    calendarEnabled = board.isPowerUpEnabled('calendar')
    showCalendar = board.owned() && !calendarEnabled

    if calendarEnabled
      $show.removeClass('hide')
    else if showCalendar
      $cal.removeClass('hide')
    return

  vigor: @VIGOR.NONE
  renderOnce: ->
    board = @model.getBoard()

    tomorrowAtNoon = moment().startOf('day').add(1, 'days').hour(12).toDate()
    dueDate = @model.getDueDate() ? DatePickerView.lastDueDate ? tomorrowAtNoon

    @$el.html template({
      canChangePowerUps: board.owned(),
      canEnableAdditionalPowerUps: board.canEnableAdditionalPowerUps(),
      upsellEnabled: !ClientConfig.get('dontUpsell')
    })

    @picker = new Pikaday
      field: @$('.js-dpicker-date-input')[0]
      container: @$('.js-dpicker-cal')[0]
      bound: false
      format: 'l'
      firstDay: moment.localeData().firstDayOfWeek()
      i18n: getPikadayStrings()
    @picker.setDate dueDate

    @$timeInput().val moment(dueDate).format(timeFormat)

    @renderCalendarPowerUp()

    @

  validateTimeInput: ->
    @$timeInput().toggleClass 'input-error', !@isTimeInputValid()

  normalizeTimeInput: ->
    @$timeInput().val @selectedTimeMoment().format(timeFormat)
    @validateTimeInput()

  selectedTimeMoment: ->
    if @isTimeInputValid()
      moment(@$timeInput().val(), parseFormat)
    else
      moment().hours(12).minutes(0)

  $timeInput: -> @$('.js-dpicker-time-input')

  isTimeInputValid: -> isTimeStringValid @$timeInput().val()

  enableCalendarPowerUp: ->
    idCalendar = LegacyPowerUps.calendar
    @model.getBoard().enablePlugin(idCalendar)
    track "Card Detail", "Enable Calendar via Due Date Menu"
    trackUe('card detail', 'enables', 'Power-Up', '', '', 'due date', idCalendar)
    return



// WEBPACK FOOTER //
// ./app/scripts/views/card/date-picker-view.coffee